"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _xhr = _interopRequireDefault(require("xhr"));
var _lodash = _interopRequireDefault(require("lodash"));
var _json = _interopRequireDefault(require("json5"));
var _Logger = _interopRequireDefault(require("./Logger"));
let log = _Logger.default.namespace('ConfigLoader');
class ConfigLoader {
  constructor() {
    this.config = Object.create(null);
    this.valReplacements = Object.create(null);
  }
  addValueReplacement(key, value) {
    this.valReplacements[key] = value;
    return this;
  }
  loadFromUrl(configUrl) {
    return new Promise((resolve, reject) => {
      (0, _xhr.default)({
        url: configUrl
      }, (err, response) => {
        if (err) {
          reject();
          return;
        }
        let configObj = null;
        try {
          configObj = _json.default.parse(response.body);
        } catch (parseErr) {
          log.error('Config ' + parseErr.message);
          let errMsg = 'Config file error: ' + parseErr.message.replace('JSON5: ', '');
          // Convert "at 22:16" to "at line 22, position 16"
          /* eslint-disable arrow-body-style */
          errMsg = errMsg.replace(/at (\d+):(\d+)/g, (m, m1, m2) => {
            return `line ${m1}, position ${m2}`;
          });
          reject(errMsg);
          return;
        }
        this.setConfig(configObj);
        resolve(this.config);
      });
    });
  }
  loadFromObj(configObj) {
    return new Promise((resolve, reject) => {
      this.setConfig(configObj);
      resolve(this.config);
    });
  }
  setConfig(confObj) {
    let walkObject = (obj, target) => {
      _lodash.default.each(obj, (_val, key) => {
        let val = _val;
        if (typeof val === 'string') {
          val = this.insertReplacements(val);
          target[key] = val;
        } else if (typeof val === 'object') {
          target[key] = _lodash.default.isArray(val) ? [] : {};
          walkObject(val, target[key]);
        } else {
          target[key] = val;
        }
      });
    };
    this.config = Object.create(null);
    walkObject(confObj, this.config);
  }
  insertReplacements(input) {
    let out = input;
    let keys = Object.keys(this.valReplacements);
    for (let i = 0; i < keys.length; i++) {
      let k = keys[i];
      if (input === '{{' + k + '}}') {
        // If we have an exact match, return the exact replacement value we have as
        // it may not be a string
        return this.valReplacements[k];
      }
      out = out.replace('{{' + k + '}}', this.valReplacements[k]);
    }
    return out;
  }
}
exports.default = ConfigLoader;
window._app_exports = window._app_exports || {};
if(!window._app_exports["libs"]) window._app_exports["libs"] = {};
window._app_exports["libs"]["ConfigLoader"]
window._app_exports.libs.ConfigLoader = exports.default ? exports.default : exports;
